import { executeGet, executePost } from '../common/apiCaller'
import { GetCategoryMstDto, PostCategoryMstDto, PostCategoryMstInputDto } from '../dto/categoryMstDto'

const apiName = 'public'
const apiPath = '/category'

export const SpecifyMasterType = {
  /** 既往症マスタ */
  MEDICAL_HISTORY: "1",
  /** 病気マスタ */
  DISEASE: "2",
  /** 症状マスタ */
  SYMPTOM: "3",
  /** 予防接種マスタ */
  VACCINATION: "4"
 
} as const

// 廃止予定。アレルギーで使用中
export const executeGetCategory = (projectId: string , category: string) => {
  return executeGet<GetCategoryMstDto[]>(apiName, `${apiPath}/${projectId}/${category}`)
}

export const executeGetCategorySpecifyMaster = (masterType: string, projectId: string, category: string) => {
  const specifyApiPath = '/category-specify-Master'
  return executeGet<GetCategoryMstDto[]>(apiName, `${specifyApiPath}/${masterType}/${projectId}/${category}`)
}

// 利用許可が1つでもあるかチェック（項目編集可否制御用）
export const executeGetHasUsagePermission = (childId: string) => {
  return executeGet<boolean>(apiName, `${apiPath}/has-usage-permission/${childId}`)
}

export const executePostCategory = (input: PostCategoryMstInputDto) => {
  return executePost<PostCategoryMstDto[]>(apiName, apiPath, input)
}